import styled from 'styled-components';

import InputText from '../../../../../components/InputText';
import { toVw, toVwMobile, toVwTablet } from '../../../../../utils/styles';
import mq from '@/utils/media-queries';

const StyledInputText = styled(InputText)`
  display: inline-block;
  width: ${toVw(400)};
  margin: 0 ${toVw(14)};
  box-sizing: border-box;

  ${mq.tablet(css`
    width: ${toVwTablet(400)};
  `)};

  ${mq.mobile(css`
    width: ${toVwMobile(312)};
  `)};
`;

export default StyledInputText;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/components/InputText.js